import {
  HIDE_LOADING,
  SHOW_LOADING,
} from "store/modules/loading/actions/actions.types";

const INITIAL_STATE: any = {
  loading: false,
};

const loading = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case SHOW_LOADING:
      return { ...state, loading: true };
    case HIDE_LOADING:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default loading;
